<template>
    <Dialog class="data-dialog" :visible="visible" :style="{ width: '34rem' }" modal :header="header"
        :closable="!loading" :closeOnEscape="!loading" @update:visible="onVisibleChange">

        <div class="data-detail-body">

            <div class="data-dialog-subject">
                <span class="pill pill-muted">ID {{ transactionId }}</span>
                <span class="pill pill-status is-neutral">{{ currentStatusLabel }}</span>
                <i class="pi pi-arrow-right"></i>
                <span class="pill pill-status" :class="targetTone">{{ targetStatusLabel }}</span>
            </div>

            <p class="confirm-delete-text">
                Esta alteração vale como o processamento do pagamento: a plataforma é avisada no
                callback e, a partir dela, nenhum retorno do gateway muda mais este status.
                <strong>Não é possível desfazer nem alterar de novo.</strong>
            </p>

            <div class="filter-field">
                <label for="manual-status-observation">Justificativa *</label>
                <Textarea id="manual-status-observation" rows="3" :minlength="10" :maxlength="255"
                    :disabled="loading" :class="{ 'p-invalid': observation.length > 0 && !isJustificationValid }"
                    :modelValue="observation" placeholder="Por que o status está sendo alterado à mão?"
                    @update:modelValue="onObservationChange" />
                <small class="data-detail-hint" :class="{ 'is-warn': !isJustificationValid }">
                    Informe pelo menos 10 caracteres. A justificativa ficará registrada no histórico.
                </small>
            </div>

        </div>

        <template #footer>
            <Button class="p-button-text" type="button" label="Cancelar" :disabled="loading" @click="close" />
            <Button type="button" :icon="targetIcon" :label="confirmLabel" :loading="loading"
                :disabled="loading || !isJustificationValid" @click="confirm" />
        </template>

    </Dialog>
</template>

<script>
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import Textarea from 'primevue/textarea'
import { computed } from 'vue'

const TARGET_TONES = {
    PAID: 'is-on',
    CANCELED: 'is-off',
}

const TARGET_ICONS = {
    PAID: 'pi pi-check-circle',
    CANCELED: 'pi pi-ban',
}

export default {
    name: 'ConfirmStatusChangeDialog',

    components: { Button, Dialog, Textarea },

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        transactionId: {
            type: [String, Number],
            default: null
        },
        // status vigente e status pretendido, já com o rótulo em pt-BR
        currentStatusLabel: {
            type: String,
            default: ''
        },
        targetStatus: {
            type: String,
            default: ''
        },
        targetStatusLabel: {
            type: String,
            default: ''
        },
        observation: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        }
    },

    emits: ['update:visible', 'update:observation', 'confirm'],

    setup(props, { emit }) {

        const header = computed(() => `Alterar status do pagamento #${props.transactionId}`)
        const confirmLabel = computed(() => `Marcar como ${props.targetStatusLabel}`)
        const targetTone = computed(() => TARGET_TONES[props.targetStatus] || 'is-neutral')
        const targetIcon = computed(() => TARGET_ICONS[props.targetStatus] || 'pi pi-check')
        const isJustificationValid = computed(() => props.observation.trim().length >= 10)

        function onVisibleChange(value) {
            emit('update:visible', value)
        }

        function onObservationChange(value) {
            emit('update:observation', value)
        }

        function close() {
            emit('update:visible', false)
        }

        function confirm() {
            if (props.loading || !isJustificationValid.value) return
            emit('confirm')
        }

        return {
            header,
            confirmLabel,
            targetTone,
            targetIcon,
            isJustificationValid,
            onVisibleChange,
            onObservationChange,
            close,
            confirm
        }
    }
}
</script>
